var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1ModeProtectionLocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 9V7.61a5.498 5.498 0 00-7.568-5.137A5.5 5.5 0 0061 7.53V9h-2v12h15V9h-2zm-4 9h-3v-6h3v6zm1-9h-5V7.53a2.48 2.48 0 011-2 2.56 2.56 0 012.32-.35A2.52 2.52 0 0169 7.61V9zm-7 19h4v38H50v-4h12V28zM10 14h16v4H14v44h12v4H10V14z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/F1_Mode_protection_locked.431ecb36.svg";
export { SvgF1ModeProtectionLocked as ReactComponent };